<template lang="pug">
.container-fluid
	.contenedor
		.contieneMenu
			.card
				.card-header.bg-dark.text-white
					span.fa.fa-info-circle.mr-2
					| Información
				.card-body.bg-danger.text-white(v-if="Texto.Editando && Texto.Editando.EdicionID !== EdicionID")
					span.fa.fa-exclamation-triangle.mr-2
					| Este texto está siendo editado por
					b  {{Texto.Editando.UsuarioNombre}}
				.card-body.bg-warning.text-dark(v-if="Texto.Editando && Texto.Editando.EdicionID === EdicionID")
					span.fa.fa-exclamation-triangle.mr-2
					| Estás editando esta noticia
					button.btn.btn-sm.btn-dark.pull-right(@click="cerrarEdicion")
						span.fa.fa-times.mr-2
						| Finalizar edición
				.row
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-12
						table.table.table-striped.m-0
							tbody
								tr
									td
										b Nombre
									td
										input.form-control(v-model="Texto.Nombre", :disabled="readonly")
								tr(:class="(Texto.Nevera) ? 'bg-primary text-white' : ''")
									td
										b Guardar en nevera
									td
										label
											input.mr-3(type="checkbox", v-model="Texto.Nevera", :disabled="readonly", @change="guardarNoticia()")
											span(v-if="Texto.Nevera") Guardado en nevera
											span(v-else)
								tr
									td
										b Autor
									td {{Texto.AutorNombre}}
								tr
									td
										b Fecha de creación
									td {{Texto.FechaCreacion}}
								tr
									td
										b Última modificación
									td {{Texto.FechaModificacion}}
								tr
									td
										b Nº de palabras
									td {{contador}}
								tr(:class="(modificado) ? 'bg-danger text-white' : ''", v-if="!readonly")
									td
										b Cambios guardados
									td
										span(v-if="modificado") No
										span.text-success(v-else) Sí
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-12
						.card-body.bg-light
							Agenda(:texto="Texto", :readonly="readonly")
						.card-body.bg-light
							Categorias(:texto="Texto", :readonly="readonly")
						.card-body.bg-light
							Etiquetas(:texto="Texto", :readonly="readonly")
				.card-footer
					button.btn.btn-sm.btn-primary.mr-2(@click="guardarNoticia", v-if="!readonly")
						span.fa.fa-save.mr-2
						| Guardar
					button.btn.btn-sm.btn-danger.mr-2(@click="eliminarNoticia", v-if="!readonly")
						span.fa.fa-trash.mr-2
						| Eliminar

					button.btn.btn-sm.btn-dark.mr-2(@click="editarNoticia()", v-if="!Texto.Editando")
						span.fa.fa-edit.mr-2
						| Editar

					button.btn.btn-sm.btn-warning.mr-2(@click="descargarPDF()")
						span.fa.fa-file-pdf-o.mr-2
						| PDF

					button.btn.btn-sm.btn-warning.mr-2(@click="imprimir = true")
						span.fa.fa-print.mr-2
						| Imprimir
		.contieneEditor(v-if="readonly")
			VisorTexto(:texto="Texto")

		.contieneEditor(v-else)
			.input-group.input-group-lg.mb-3.inp
				.input-group-prepend
					.input-group-text Titular
				input.form-control(v-model="Texto.Titular")
			.input-group.input-group-lg.mb-3.inp
				.input-group-prepend
					.input-group-text Lead
				textarea.form-control(rows="6", v-model="Texto.Lead")
			vue-mce.editor(:config="configuracionEditor", v-model="Texto.Texto", v-if="!readonly")

		.contieneImagenes
			Audios(:texto="Texto", :readonly="readonly")
			Imagenes(:texto="Texto", :palabras-clave="palabrasClave", :readonly="readonly")
			PalabrasClave(:palabras-clave="palabrasClave")
	imprimir(v-if="imprimir", @imprimir="goImprimir($event)", @cerrar="imprimir=false")
</template>

<script>
import Etiquetas from './etiquetas'
import Categorias from './categorias'
import Agenda from './agenda'
import Audios from './audios'
import Imagenes from './imagenes'
import PalabrasClave from './palabrasClave'
import VisorTexto from './visor-texto'
import axios from 'axios'
export default {
	components: {
		Etiquetas,
		Agenda,
		Categorias,
		Audios,
		Imagenes,
		PalabrasClave,
		VisorTexto
	},
	data () {
		return {
			Texto: {
				NoticiaID: null,
				Nombre: '',
				Nevera: false,
				Titular: '',
				Lead: '',
				Audios: [],
				Imagenes: [],
				Etiquetas: [],
				Categorias: [],
				Texto: ''
			},
			EdicionID: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: [
					'advlist autolink lists link image charmap print preview anchor textcolor',
					'searchreplace visualblocks code fullscreen',
					'insertdatetime media table contextmenu paste code help wordcount paste'
				],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: `
					table {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}
					table tr:nth-child(even) {background-color: #fafafa;}
					table td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}
				`
			},
			modificado: false,
			intervalo: null,
			intervaloEditando: null,
			imprimir: false
		}
	},
	created () {
		if (this.$route.params.id !== 'nueva') {
			// Buscamos
			this.Texto.NoticiaID = this.$route.params.id
			this.obtenerNoticia()
		} else {
			this.guardarNoticia(true)
		}
		this.intervalo = window.setInterval(() => {
			this.guardarNoticia()
		}, 30000)

		this.intervaloEditando = window.setInterval(() => {
			this.actualizaEditando()
		}, 10000)
	},
	beforeDestroy () {
		window.clearInterval(this.intervalo)
		window.clearInterval(this.intervaloEditando)

		if (this.EdicionID) {
			this.cerrarEdicion()
		}
	},
	watch: {
		'Texto.Texto': function (newVal) {
			this.modificado = true
		},
		'Texto.Titular': function (newVal) {
			this.modificado = true
		}
	},
	computed: {
		readonly () {
			if (!this.Texto) {
				return false
			}

			if (this.Texto.Editando && this.Texto.Editando.EdicionID === this.EdicionID) {
				return false
			}
			return true
		},
		contador () {
			if (!this.Texto.Texto) {
				return 0
			}
			const striped = this.Texto.Texto.replace(/<[^>]*>/gm, '')
			const resultado = striped.match(/[^\s]\s/gm)
			if (!resultado) {
				return 1
			}
			return resultado.length + 1
		},
		palabrasClave () {
			if (!this.Texto.Texto) {
				console.log('No hay texto')
				return new Map()
			}
			let striped = this.Texto.Texto.replace(/<[^>]*>/gm, '')
			striped = striped.replace(/&aacute;/igm, 'á')
			striped = striped.replace(/&eacute;/igm, 'é')
			striped = striped.replace(/&iacute;/igm, 'í')
			striped = striped.replace(/&oacute;/igm, 'ó')
			striped = striped.replace(/&uacute;/igm, 'ú')
			striped = striped.replace(/(ntilde|nbsp)/igm, '')
			striped = striped.replace(/(cuando|había|ante|contra|saber|tras|según|hasta|para)/igm, '')
			const resultado = striped.match(/\s?([\wáéíóú]{4,})\s?/igm)
			if (!resultado) {
				return new Map()
			}

			return resultado.reduce((ant, palabra) => {
				palabra = palabra.trim().toUpperCase()
				if (palabra.length > 1) {
					if (ant.has(palabra)) {
						let cant = ant.get(palabra)
						ant.set(palabra, cant + 1)
					} else {
						ant.set(palabra, 1)
					}
				}
				return ant
			}, new Map())
		}
	},
	methods: {
		cerrarEdicion () {
			const form = {
				NoticiaID: this.Texto.NoticiaID,
				EdicionID: this.EdicionID
			}
			axios.post('redaccion/php/api/del-editando.php', form)
				.then(() => {
					console.log('Cerrando la edición')
					this.EdicionID = null
					this.Texto.Editando = null
				})
				.catch(this.$responseError)
		},
		actualizaEditando () {
			if (this.EdicionID) {
				const form = {
					NoticiaID: this.Texto.NoticiaID,
					EdicionID: this.EdicionID
				}

				axios.post('redaccion/php/api/set-editando.php', form)
					.then(res => {
						this.EdicionID = res.data.EdicionID
					})
					.catch(() => {
						this.EdicionID = null
					})
			} else {
				this.obtenerNoticia()
			}
		},
		obtenerNoticia () {
			axios.get('redaccion/php/api/get-noticia.php?NoticiaID=' + this.Texto.NoticiaID)
				.then(res => {
					this.Texto = res.data
				})
				.catch(this.$responseError)
		},
		editarNoticia () {
			const form = {
				NoticiaID: this.Texto.NoticiaID,
				EdicionID: this.EdicionID
			}
			axios.post('redaccion/php/api/editar-noticia.php', form)
				.then(resEd => {
					this.obtenerNoticia()
					this.EdicionID = resEd.data.EdicionID
				})
				.catch(this.$responseError)
		},
		guardarNoticia (ini) {
			if ((!this.modificado || !this.EdicionID) && !ini) {
				return
			}

			const form = JSON.parse(JSON.stringify(this.Texto))
			form.NumeroPalabras = this.contador
			form.PalabrasClave = Array.from(this.palabrasClave).reduce((ant, actual) => {
				ant.push({
					Palabra: actual[0],
					Apariciones: actual[1]
				})
				return ant
			}, [])
			axios.post('redaccion/php/api/set-noticia.php', form)
				.then(res => {
					this.Texto.NoticiaID = res.data.NoticiaID
					this.$store.commit('toast/success', {
						titulo: 'Autoguardado',
						mensaje: 'Se han guardado los cambios automáticamente'
					})
					this.modificado = false

					if (ini) {
						this.editarNoticia()
					}
				})
				.catch(this.$responseError)
		},
		eliminarNoticia () {
			if (!this.Texto.NoticiaID) {
				return
			}

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar noticia',
				mensaje: `¿Quieres eliminar este noticia?`,
				callback: acepta => {
					if (acepta) {
						axios.delete('redaccion/php/api/del-noticia.php?NoticiaID=' + this.Texto.NoticiaID)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Noticia eliminada',
									mensaje: 'Se ha eliminado la noticia correctamente'
								})
								this.$router.push('/main/redaccion')
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		descargarPDF () {
			window.location.href = '/src/modulos/redaccion/php/api/get-pdf.php?NoticiaID=' + this.Texto.NoticiaID
		},
		goImprimir (opciones) {
			console.log(opciones)
			const form = {
				OpcionesImpresion: opciones,
				Noticias: [this.Texto.NoticiaID]
			}

			axios.post('redaccion/php/api/imprimir.php', form)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Impresión iniciada'
					})
				})
				.catch(this.$responseError)
		}
	}
}
</script>


<style scoped>

.contenedor {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
	align-content: stretch;
	align-items: stretch;
	align-self: stretch;
	flex-wrap: nowrap;
}

.colIzq {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	flex-grow: 1;
	flex-basis: 1;
	flex-shrink: 1;
	max-width: 450px;
}

.contieneMenu {
	position: relative;
	flex-grow: 1;
	flex-basis: 1;
	flex-shrink: 1;
	padding: 10px;
	max-width: 450px;
	min-width: 250px;
}

.contieneEditor {
	position: relative;
	padding: 10px;
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 1;
	/* max-width: 814px;
	min-width: 814px; */
}

.contieneImagenes {
	position: relative;
	padding: 10px;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 1;
	min-width: 100px;
	max-width: 490px;
}

.titular {
	display: none;
}

.lead {
	display: none;
}

.hoja {
	background-color: white;
	padding: 10px;
	display: inline-block;
	position: relative;
	width: 100%;
	max-width: 210mm;
}

.hojaPrint {
	display: none;
}


@media (max-width: 1200px) {
	.contenedor {
		flex-direction: column;
	}

	.colIzq {
		max-width: 100%;
		min-width: 100%;
	}
	.contieneMenu {
		max-width: 100%;
		min-width: 100%;
	}

	.contieneEditor {
		max-width: 100%;
		min-width: 100%;
	}
}

@media print {
	.contenedor {
		display: block;
		position: relative;
	}
	.colIzq {
		display: none;
	}

	.contieneMenu {
		display: none;
	}

	.contieneEditor {
		position: relative;
		display: block;
	}

	.titular {
		position: relative;
		display: block;
		font-size: 2em;
		font-weight: bold;
		margin-bottom: 20px;
	}

	.inp {
		display: none;
	}
	.lead {
		position: relative;
		display: block;
		font-size: 1.5em;
		padding-bottom: 20px;
		border-bottom: 1px solid #e0e0e0;
		margin-bottom: 20px;
		padding: 5px;
	}

	.hoja {
		position: relative;
		display: block;
		margin: 0;
		padding: 5px;
		font-size: 1.5em;

		background-color: white;
		max-width: inherit;
	}

	.hojaPrint {
		position: relative;
		display: block;
		margin: 0;
		padding: 5px;
		font-size: 1.5em;

		background-color: white;
		max-width: inherit;
	}

	.editor {
		display: none !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/editor.vue